import { useId } from 'react';
import { useT } from '../i18n/index.js';

/**
 * «Envío», the row above the total of the till and of a new order (the owner, 2026-10-12: «it
 * should be like an optional field above total»): the word and the amount, as the receipt prints
 * them. Empty, as most sales are, it says 0.00 and adds nothing.
 *
 * Not focused by anything: the till's cursor belongs to its search, and a scan made with the cursor
 * here goes there all the same (`useLectorUsb`).
 */
export function CampoEnvio({
  valor,
  onCambio,
  error,
}: {
  valor: string;
  onCambio: (valor: string) => void;
  /** What is wrong with what is typed, said under it: not an amount, or more than the books hold. */
  error: string | null;
}) {
  const t = useT();
  const id = useId();
  return (
    <div className="mb-2" data-envio>
      <div className="flex items-center justify-between gap-3">
        <label htmlFor={id} className="text-sm text-slate-400">
          {t('envio.campo')}
        </label>
        <input
          id={id}
          inputMode="decimal"
          enterKeyHint="done"
          autoComplete="off"
          placeholder="0.00"
          value={valor}
          onChange={(e) => onCambio(e.target.value)}
          // Selected on the way in: the amount typed replaces what was there instead of following it.
          onFocus={(e) => e.currentTarget.select()}
          onKeyDown={(e) => {
            if (e.key !== 'Enter') return;
            // Puts the keyboard away, and the total and the button in view; it presses nothing.
            e.preventDefault();
            e.currentTarget.blur();
          }}
          aria-invalid={error ? true : undefined}
          className={`campo tabular h-11 min-h-0 w-36 text-right ${error ? 'ring-2 ring-rose-600' : ''}`}
        />
      </div>
      {error && <p className="mt-1 text-right text-xs text-rose-400">{error}</p>}
    </div>
  );
}
